import { SettingValues } from "@linearb/linjs-common";
import { SETTING_NAMES, SUPPORTED_CHAT_TOOLS } from "common/constants/constants";

/**
 * Notification types that are desplayed on the settings page
 */
export const NOTIFICATION_TYPES = [
  SettingValues.PULL_REQUESTS_LARGER_THAN,
  SettingValues.PULL_REQUESTS_OPEN_MORE_THAN,
  SettingValues.WORK_AT_RISK_NOTIFICATION,
  SettingValues.MERGED_WITHOUT_REVIEW_NOTIFICATION,
  SettingValues.MERGED_WITH_BASIC_REVIEW_NOTIFICATION,
  SettingValues.REVIEW_REQUEST_HANGING_NOTIFICATION,
  SettingValues.REVIEW_TOO_LONG_NOTIFICATION,
  SettingValues.DAILY_DIGEST_NOTIFICATION_THRESHOLDS,
  SettingValues.STALE_ISSUES_NOTIFICATION_THRESHOLDS,
  SettingValues.UNLINKED_BRANCHES
];

/**
 * Map of collaboration type and the relevant setting collaboration channel name
 */
export const collaborationTypeToSettingName = {
  [SUPPORTED_CHAT_TOOLS.MSTEAMS]: SETTING_NAMES.TEAM_MSTEAMS_CHANNEL,
  [SUPPORTED_CHAT_TOOLS.SLACK]: SETTING_NAMES.TEAM_SLACK_CHANNEL
};

export type Collaborations = (typeof SUPPORTED_CHAT_TOOLS)[keyof typeof SUPPORTED_CHAT_TOOLS]

export interface CollaborationSetting {
  teamId: number,
  collaborationType: Collaborations,
  teamCollaborationChannelConfigId: number,
  allSettings: any,
  defaultSettingsIds: number[],
  notificationEnableSetting: any,
  defaultNotifications: any,
  defaultNotificationValues?: any,
  isTeamWithDetails?: boolean
}
